import { Typography, styled } from '@mui/material'
import { ViewIcon } from '$common/icons/view'
import { formatViews, toLocale } from '$func/text'
import { t } from '$i18n'

const Container = styled('div')`
  display: flex;
  /* @noflip */
  margin-right: 8px;
  flex-direction: row;
  align-items: center;
`

const ViewsTypography = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 12px;
  letter-spacing: -0.5px;
  padding-top: 2px;
  /* @noflip */
  margin-right: 4px;
`

const PostfixTypography = styled(ViewsTypography)`
  padding-bottom: 1px;
  /* @noflip */
  margin-right: 2px;
`

export function Views({ views }: { views: number }) {
  if (!views) return null

  const { shortenedViews, postfix } = formatViews(views)
  return (
    <Container>
      <ViewIcon />

      <ViewsTypography>{shortenedViews}</ViewsTypography>
      <PostfixTypography>{postfix}</PostfixTypography>
    </Container>
  )
}
